/**
 * formDeriveProjectionRowId
 *
 * Mints the document id of a projected target row. Deterministic and pure: two
 * concurrent reconcilers reading the same source rows write the same ids, so a
 * fencing failure degrades to overwriting identical bytes. The id embeds the
 * deriveId, which is what lets the engine claim and repair a row whose
 * `deriveOwner` is missing or forged instead of blocking that slot forever.
 *
 * One key shape, `unique`: a projected row IS a group of the partition key, and
 * the key hashes the group's canonical value — any string — into fixed length.
 * Accepted risk: fnv1a64 collides with probability ~2.7e-12 at 10k distinct
 * values, and a collision merges two distinct values into one row.
 */

import { FORM_DERIVE_ROW_ID_PREFIX } from '../System.FormDerive.types';
import type { FormDeriveId } from '../System.FormDerive.types';
import type { ArRowId } from '../System.Artifacts.types';
import { fnv1a64 } from '../fnv1a64';

function formDeriveProjectionRowId(
  deriveId: FormDeriveId,
  key: { kind: 'unique'; canonicalValue: string },
): ArRowId {
  return `${FORM_DERIVE_ROW_ID_PREFIX}${deriveId}~${fnv1a64(key.canonicalValue)}`;
}

export { formDeriveProjectionRowId };
